import { ILoadPageResult } from 'page/layout-build-types.js';
import * as React from 'react';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'redux-state/configure-store.js';
import { REDUX_LOADING_FALSE } from 'redux-state/loading/reducer.js';
import { getWindow } from 'utilities/window.js';
import { MainPage } from './main-5-page.js';
import { JsonResultType } from './utils/json-page-change.js';
import { JsonUpdateBuildLayoutHook } from './utils/layout-build-from-json.js';

export const MainPageLayoutHook = ({ pageJson }: { pageJson: JsonResultType }) => {
  const appDispatch = useAppDispatch();

  /** Current Layout Type Loaded e.g. five-up, map etc. */
  const currentLayoutType = useAppSelector((state) => state.LAYOUT.screen.layout.name);
  const currentLayoutTypeRef = React.useRef(currentLayoutType);

  useEffect(() => {
    currentLayoutTypeRef.current = currentLayoutType;
  }, [currentLayoutType]);

  const [pageLayoutResult, setPageLayoutResult] = React.useState<ILoadPageResult>();

  /** Parse page payload to load layout components */
  const jsonLayoutResult = JsonUpdateBuildLayoutHook({ pageJson, currentLayoutTypeRef });

  useEffect(() => {
    setPageLayoutResult(jsonLayoutResult);
  }, [jsonLayoutResult]);

  useEffect(() => {
    /** Page Layout has loaded */
    if (pageLayoutResult) {
      appDispatch(REDUX_LOADING_FALSE());
    }
    // const pathRef = getPathRef();
    // if (pageLayoutResult?.layoutLoadSuccess && pathRef) {
    //   /** Once loaded pageJson correctly set the current url */
    //   appDispatch(REDUX_ROUTING_SET_CURRENT_URL({ currentUrl: pathRef }));
    // }
  }, [pageLayoutResult, appDispatch]);

  /**
   * When moving from one page to another browser will try to go to the same position.
   * As its an SPA to the browser its the same window so its refreshing the page and goes to the previous page position
   * We need to reset this.
   */
  React.useEffect(() => {
    getWindow()?.scrollTo(0, 0);
  }, [pageLayoutResult]);

  return { pageLayoutResult };
};

const _MainPageLayout = ({ pageJson, children }: { pageJson: JsonResultType; children: JSX.Element }) => {
  const { pageLayoutResult } = MainPageLayoutHook({ pageJson });
  return <MainPage pageLayoutResult={pageLayoutResult}>{children}</MainPage>;
};

export const MainPageLayoutV2 = React.memo(_MainPageLayout);
